import React from "react"
import { Link } from "react-router-dom"
import chartIcon from "../../../assets/images/icons/chartIcon.svg"
import { Card, CardBody } from "reactstrap"
import Breadcrumb from "components/Common/Breadcrumb"

const NewAndUpdates = ({ data, close }) => {
  return (
    <>
      <Card>
        <div className="page-search-title">
          <Breadcrumb title={" News & Updates"} />
        </div>

        <CardBody className="mt-5">
          <div className="blog-search-box-wrapper">
            {data?.data.map((item, index) => (
              <div
                key={`blog_${index}`}
                className="d-flex align-items-center gap-3 blog-list-inner-box"
              >
                <div className="chart-icon">
                  <img src={chartIcon} alt="" />
                </div>
                <div className="">
                  <Link to={`/resources/blog/${item?.id}`} onClick={close}>
                    <h6>{item.title}</h6>
                    <p>View more detail →</p>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </CardBody>
      </Card>
    </>
  )
}

export default NewAndUpdates
